export default {"src":"/_next/static/media/ALE.dd7aeda2.svg","height":18,"width":18};